import { PromiseToPay, Receipt } from "@/types/payments";

/**
 * Mock Promise to Pay data for testing
 */
export const mockPromises: PromiseToPay[] = [
  {
    id: "promise-001",
    customerId: "customer-001",
    promisedDate: new Date("2025-01-15"),
    promisedAmount: 1250.0,
    status: "Pending",
    promisedTransactions: [
      {
        transactionId: "txn-001",
        transactionNumber: "INV-2024-001",
        promisedAmount: 500.0,
        priority: 1,
        currentBalance: 500.0,
      },
      {
        transactionId: "txn-003",
        transactionNumber: "INV-2024-003",
        promisedAmount: 450.0,
        priority: 2,
        currentBalance: 450.0,
      },
      {
        transactionId: "txn-005",
        transactionNumber: "INV-2024-005",
        promisedAmount: 300.0,
        priority: 3,
        currentBalance: 300.0,
      },
    ],
  },
  {
    id: "promise-002",
    customerId: "customer-002",
    promisedDate: new Date("2025-01-20"),
    promisedAmount: 800.0,
    status: "Pending",
    promisedTransactions: [
      {
        transactionId: "txn-010",
        transactionNumber: "INV-2024-010",
        promisedAmount: 800.0,
        priority: 1,
        currentBalance: 800.0,
      },
    ],
  },
];

/**
 * Mock Receipt data for testing (matching promise-001)
 */
export const mockReceiptsWithPromise: Receipt[] = [
  {
    id: "receipt-001",
    receiptNumber: "RCP-2025-001",
    customerId: "customer-001",
    customerName: "ABC Company Ltd",
    customerAccountNumber: "ACC-001",
    receiptDate: new Date("2025-01-15"),
    receivedAmount: 1250.0,
    allocatedAmount: 0,
    unappliedAmount: 1250.0,
    currency: "GBP",
    allocationStatus: "unallocated",
    reconciliationStatus: "pending",
    paymentMethod: "bank_transfer",
    paymentReference: "BACS-12345",
    financeSystemId: "FS-001",
    importedAt: new Date("2025-01-15"),
    notes: "Payment received via bank transfer",
    createdAt: new Date("2025-01-15"),
    createdBy: "system",
    hasPromise: true,
    promiseToPayId: "promise-001",
  },
  {
    id: "receipt-002",
    receiptNumber: "RCP-2025-002",
    customerId: "customer-002",
    customerName: "XYZ Corporation",
    customerAccountNumber: "ACC-002",
    receiptDate: new Date("2025-01-20"),
    receivedAmount: 800.0,
    allocatedAmount: 0,
    unappliedAmount: 800.0,
    currency: "GBP",
    allocationStatus: "unallocated",
    reconciliationStatus: "pending",
    paymentMethod: "cheque",
    paymentReference: "CHQ-67890",
    financeSystemId: "FS-002",
    importedAt: new Date("2025-01-20"),
    notes: "Cheque payment",
    createdAt: new Date("2025-01-20"),
    createdBy: "system",
  },
];
